import React from 'react';
import { Table, Empty, Button, Input, Form, Tooltip, DatePicker, Icon } from 'antd';
import { FORMAT_3DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import moment from 'moment';
import { VALIDAR_STOCK } from '../../../../common/types/parametroType'
import auth from '../../../../common/utility/auth';

export default function Productos (props) {
    const validarStock = auth.user().parametros.filter(m => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;

    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}

                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row.identifier)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'OC',
                        dataIndex: 'ordenCompra',
                        key: 'ordenCompra',
                        align: 'center',
                        width: 80,
                        ellipsis: true
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 80,
                        ellipsis: true
                    },
                    {
                        title: 'Producto',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 300,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {
                                        props.onGetFieldDecorator(`arrNombre[${row.identifier}]`, {
                                            initialValue: value
                                        })(
                                            <Input
                                                placeholder="Nombre"
                                                autoComplete="off"
                                                className="text-left"
                                                readOnly={true}
                                                // onClick={(e) => props.onChangeNameProduct(row)}
                                            />
                                        )
                                    }

                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFechaVencimiento[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrFechaVencimiento", e.target.value, 0, row.idProducto)}
                                            disabledDate={d => !d || d.isBefore(row.minFechaStr)}
                                            disabled={row.isReadOnly}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    

                    {
                        title: 'Lote',
                        dataIndex: 'lote',
                        key: 'lote',
                        align: 'center',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrLote[${row.identifier}]`, {
                                        initialValue: value
                                        //rules: [{
                                        //    required: true
                                        //}]
                                    })(
                                        <Input
                                            placeholder="Lote"
                                            autoComplete="off"
                                            className="text-left"
                                            onBlur={(e) => props.onCalculateDetail(row.identifier, "arrLote", e.target.value, 0, row.idProducto)}
                                            disabled={row.isReadOnly}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Tooltip title={validarStock ? (row.stock ? `Stock Disponible: ${row.stock.toFixed(2)}` : '') : ''}>
                                    <Form.Item>
                                        {props.onGetFieldDecorator(`arrCantidad[${row.identifier}]`, {
                                            initialValue: parseFloat(value),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(GREATER_THAN_ZERO),
                                                message: "Formato (0)"
                                            }]
                                        })(
                                            <Input
                                                placeholder="Cantidad"
                                                autoComplete="off"
                                                className="text-right"
                                                // max="2"
                                                onBlur={(e) => props.onCalculateDetail(row.identifier, "arrCantidad", e.target.value, 0, row.idProducto)}
                                                disabled={row.isReadOnly}
                                            />
                                        )}
                                    </Form.Item>
                                </Tooltip>
                            );
                        }
                    },
                    
                    {
                        title: 'Origen',
                        children: [
                            {
                                title: 'Precio Unitario',
                                dataIndex: 'precioUnitarioOrigen',
                                key: 'precioUnitarioOrigen',
                                align: 'center',
                                width: 90,
                                render: (value, row) => {
                                    return (
                                        
                                        <Form.Item>
                                            {props.onGetFieldDecorator(`arrPrecioUnitarioOrigen[${row.identifier}]`, {
                                                initialValue: parseFloat(value).toFixed(3),
                                                rules: [{
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                }]
                                            })(
                                                <Input
                                                    placeholder="P.  Unitario"
                                                    autoComplete="off"
                                                    className="text-right"
                                                    onBlur={(e) => props.onCalculateDetail(row.identifier, "arrPrecioUnitarioOrigen", e.target.value, 5, row.idProducto)}
                                                    disabled={row.isReadOnly}
                                                />
                                            )}
                                        </Form.Item>
                                    );
                                }
                            },
                            {
                                title: 'Total',
                                dataIndex: 'totalOrigen',
                                key: 'totalOrigen',
                                // fixed: 'right',
                                align: 'center',
                                width: 90,
                                render: (value, row) => {
                                    return (
                                        <Form.Item>
                                            {props.onGetFieldDecorator(`arrTotalOrigen[${row.identifier}]`, {
                                                initialValue: parseFloat(value).toFixed(3),
                                                rules: [{
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Total"
                                                    autoComplete="off"
                                                    className="text-right"
                                                    disabled={true}
                                                />
                                            )}
                                        </Form.Item>
                                    );
                                }
                            }
                        ]
                    },

                    {
                        title: 'Costeo',
                        children: [
                            {
                                title: 'Precio Unitario',
                                dataIndex: 'precioUnitarioCosteo',
                                key: 'precioUnitarioCosteo',
                                align: 'center',
                                width: 90,
                                render: (value, row) => {
                                    return (
                                        
                                        <Form.Item>
                                            {props.onGetFieldDecorator(`arrPrecioUnitarioCosteo[${row.identifier}]`, {
                                                initialValue: parseFloat(value).toFixed(3),
                                                rules: [{
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                }]
                                            })(
                                                <Input
                                                    placeholder="P.  Unitario"
                                                    autoComplete="off"
                                                    className="text-right"
                                                    disabled={true}
                                                    // onBlur={(e) => props.onCalculateDetail(row.identifier, "arrPrecioUnitarioCosteo", e.target.value, 5, row.idProducto)}
                                                />
                                            )}
                                        </Form.Item>
                                    );
                                }
                            },
                            {
                                title: 'Total',
                                dataIndex: 'totalCosteo',
                                key: 'totalCosteo',
                                // fixed: 'right',
                                align: 'center',
                                width: 90,
                                render: (value, row) => {
                                    return (
                                        <Form.Item>
                                            {props.onGetFieldDecorator(`arrTotalCosteo[${row.identifier}]`, {
                                                initialValue: parseFloat(value).toFixed(3),
                                                rules: [{
                                                    required: true,
                                                    pattern: new RegExp(FORMAT_3DECIMALS),
                                                    message: "Formato (0.00)"
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Total"
                                                    autoComplete="off"
                                                    className="text-right"
                                                    disabled={true}
                                                />
                                            )}
                                        </Form.Item>
                                    );
                                }
                            }
                        ]
                    }

                    
                ]}

            />
        </div>

    )
}